import { ZERO_ROTATION, type CartesianPose } from '@sb/geometry';

/**
 * Flange to tool mounting face, in meters: the 37.5 mm sensor body plus the
 * 4 mm `COUPLING_G-50-4M6-1D6` flat coupling.
 *
 * A coupling is mandatory on the FT-300, so the bare body height is never the
 * right offset. Matches the flange joint origin in ROS-Industrial's
 * `example_use_robotiq_ft300.urdf`. A different coupling changes only this
 * number.
 */
export const ROBOTIQ_FT_300_TOOLTIP_Z = 0.0415;

/** Datasheet mass, matching the URDF's inertial block. */
export const ROBOTIQ_FT_300_MASS_KG = 0.3;

/**
 * Snapshotted into the config when a row is created, so changing the constant
 * does not move rows that already exist.
 */
export const ROBOTIQ_FT_300_DEFAULT_TOOLTIP_TRANSFORM = {
  ...ZERO_ROTATION,
  x: 0,
  y: 0,
  z: ROBOTIQ_FT_300_TOOLTIP_Z,
} satisfies CartesianPose;

/**
 * 75 mm outside diameter, boxed. Config coordinates, meters.
 *
 * Spans the full flange-to-tool height rather than the 37.5 mm body alone: the
 * mandatory coupling is part of the swept volume, and stopping at the body
 * would leave the 4 mm ring above it unmodelled while the planner puts the tool
 * tip at its far side.
 */
export const ROBOTIQ_FT_300_DEFAULT_COLLISION_BOX = {
  origin: { x: 0, y: 0, z: ROBOTIQ_FT_300_TOOLTIP_Z / 2 },
  size: { x: 0.075, y: 0.075, z: ROBOTIQ_FT_300_TOOLTIP_Z },
} as const;
